import { useLang } from "../i18n";

export const AudienceTag = ({ audience, dark = false, testId }) => {
  const { t } = useLang();
  const isBiz = audience === "business";
  const cls = isBiz
    ? dark
      ? "border border-[#8FA3C8] text-[#B7C6E2]"
      : "border border-navy text-navy"
    : dark
      ? "border border-coral-light text-coral-light bg-coral-light/10"
      : "bg-coral-muted text-coral-dark";
  return (
    <span
      data-testid={testId}
      className={`inline-block text-[11px] font-mono font-medium tracking-[0.14em] px-2.5 py-1 rounded-full ${cls}`}
    >
      {isBiz ? t("common.forBusiness") : t("common.forIndividuals")}
    </span>
  );
};
